import React from "react";
import { useMediaQuery } from "@mui/material";

import Header from "../../Common/Header";
import SignUpMobile from "./SignUpMobile";
import SignUpWeb from "./SignUpWeb";

const SignUp = () => {
  const isSmallScreen = useMediaQuery("(max-width:960px)");

  return isSmallScreen ? <SignUpMobile /> : <><Header/><SignUpWeb /></>;
};

export default SignUp;
